import * as types from '../mutation-types'

const state = {
  showWidget: false,
  showBrowserWarning: true,
  showSubmissionWarning: false
}

const getters = {
  shouldShowWidget: (state) => {
    return state.showWidget
  },
  shouldShowBrowserWarning: (state) => {
    return state.showBrowserWarning
  },
  shouldShowSubmissionWarning: (state) => {
    return state.showSubmissionWarning
  }
}

const actions = {
  updateShowWidget ({ commit }, showWidget) {
    commit(types.UPDATE_SHOW_WIDGET, showWidget)
  },
  closeBrowserWarning ({ commit }) {
    localStorage.setItem('browserWarning', '0')
    commit(types.SET_BROWSER_WARNING, false)
  },
  checkBrowserWarning ({ commit }) {
    // Check if browserWarning localStorage key exists
    if (localStorage.getItem('browserWarning')) {
      commit(types.SET_BROWSER_WARNING, false)
    }
  },
  showSubmissionWarning ({ commit }) {
    commit(types.SET_SHOW_SUBMISSION_WARNING, true)
  },
  closeSubmissionWarning ({ commit }) {
    commit(types.SET_SHOW_SUBMISSION_WARNING, false)
  }
}
const mutations = {
  [types.UPDATE_SHOW_WIDGET] (state, showWidget) {
    state.showWidget = showWidget
  },
  [types.SET_BROWSER_WARNING] (state, showBrowserWarning) {
    state.showBrowserWarning = showBrowserWarning
  },
  [types.SET_SHOW_SUBMISSION_WARNING] (state, showSubmissionWarning) {
    state.showSubmissionWarning = showSubmissionWarning
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
